import { NgModel } from "@angular/forms";

export const dateControlValidator = (controls: NgModel[]): string | null => controls?.find(control => control?.control?.errors)?.control?.errors?.message ?? null;
